
(() => {

    let filter = document.querySelector('.filter')

    if(filter) {

        let label = filter.querySelector('.mobile-dropdown')
        if(label) {
            let options = filter.querySelector('.filter--options')

            label.addEventListener('click', () => {
                options.classList.toggle('open')
            })
        }
    }

})()
